import React__default, { createRef, useCallback } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useStyles, mergeRefs } from '@sravni/react-utils';
import { TooManyRequestsError, BadRequestError } from '@sravni/utils/lib/errors/network';
import { yupResolver } from '@hookform/resolvers/yup';
import { DEFAULT_ERROR_MESSAGE } from '../../constansts/index.js';
import { convertDefaultValues, joinRetryAfterAndErrorType } from '../../helpers/utils.js';
import { useAutoSubmitForm } from '../../hooks/useAutoSubmitForm.js';
import '../ContextProvider/components/IsLoadingProvider/provider.js';
import { useIsLoading } from '../ContextProvider/components/IsLoadingProvider/hook.js';
import '../ContextProvider/components/UserManagerProvider/provider.js';
import { useUserManager } from '../ContextProvider/components/UserManagerProvider/hook.js';
import '../ContextProvider/components/ValidationContextProvider/provider.js';
import { useValidationContext } from '../ContextProvider/components/ValidationContextProvider/hook.js';
import modules_13b53a7e from './styles.module.less.js';
import { getValidationSchema, validationSchema } from './validationSchema.js';

/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable max-statements */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/init-declarations */
/** Компонент формы. Реализует сабмит, валидацию полей */
const Form = React__default.forwardRef((props, ref) => {
    const { defaultValues, onLogin, onSubmit: onSubmitOutside, onError, onLoginFailed, children, className = '', additionalValidationSchema, enableAutoSubmit = false, disabled = false, ...restProps } = props;
    const userManager = useUserManager();
    const [validationContext] = useValidationContext();
    const [isLoading, setIsLoading] = useIsLoading();
    const methods = useForm({
        disabled: disabled || isLoading,
        defaultValues: convertDefaultValues(defaultValues),
        mode: 'onSubmit',
        reValidateMode: 'onChange',
        resolver: yupResolver(getValidationSchema(validationSchema, additionalValidationSchema)),
        context: validationContext,
    });
    const cx = useStyles(modules_13b53a7e);
    const formRef = createRef();
    const { setError, setValue } = methods;
    const handleSubmit = useCallback((data, e) => {
        if (isLoading)
            return;
        userManager.prepare();
        const { ["phone" /* FIELD_NAME.PHONE */]: phone, ["code" /* FIELD_NAME.OTP */]: code } = data;
        onSubmitOutside?.(data, e);
        setIsLoading(true);
        const asyncFn = async () => {
            const result = await userManager.login({ phone, code });
            setIsLoading(false);
            if (result.isErr()) {
                setValue("code" /* FIELD_NAME.OTP */, '');
                if (result.error instanceof TooManyRequestsError) {
                    const { retryAfter } = result.error;
                    if (!retryAfter) {
                        setError("root.server" /* FIELD_NAME.SERVER */, { message: `Слишком много попыток, попробуйте позднее` });
                        return;
                    }
                    setError("root.server" /* FIELD_NAME.SERVER */, {
                        type: joinRetryAfterAndErrorType(retryAfter),
                        message: `Слишком много попыток, попробуйте снова через`,
                    });
                    return;
                }
                if (result.error instanceof BadRequestError) {
                    const { target = "root.server" /* FIELD_NAME.SERVER */ } = result.error;
                    setError(target, { message: result.error.message || DEFAULT_ERROR_MESSAGE });
                    return;
                }
                setError("root.server" /* FIELD_NAME.SERVER */, { message: DEFAULT_ERROR_MESSAGE });
                onLoginFailed?.(result.error);
                return;
            }
            onLogin?.(data);
        };
        asyncFn();
    }, [isLoading, onLogin, onLoginFailed, onSubmitOutside, setError, setIsLoading, setValue, userManager]);
    useAutoSubmitForm({
        enabled: enableAutoSubmit && !disabled,
        formRef,
        methods,
    });
    return (React__default.createElement(FormProvider, { ...methods },
        React__default.createElement("form", { ...restProps, onSubmit: methods.handleSubmit(handleSubmit, onError), className: cx('form', className), ref: mergeRefs(formRef, ref) }, children)));
});

export { Form };
//# sourceMappingURL=view.js.map
